import LibGenerateTestUserSig from './lib-generate-test-usersig-es.min.js'
import { showNotify } from 'vant';

/* eslint-disable */
const SDKAPPID = process.env.VUE_APP_SDK_APP_ID
const SECRETKEY = '69bbdbe0ce9ed0e489ab8ad6b432aa72592c2898916e4c2b972f32f96e8c2fb4'
function genTestUserSig (userID) {
  var EXPIRETIME = 604800;
  var generator = new LibGenerateTestUserSig(SDKAPPID, SECRETKEY, EXPIRETIME);
  var userSig = generator.genTestUserSig(userID);
  return {
    SDKAPPID: SDKAPPID,
    userSig: userSig
  };
}

/**
 * 判断数据的类型是否符合预期
 * 只传一个参数data，则返回数据的类型；
 * 传入多个参数，则判断数据是否属于该类型（或属于类型数组中的一个）
 * @param {*} data 需要判断类型的数据
 * @param  {...any} typeList 字符串或字符串数组，可不传
 */
function isDataType (data, ...typeList) {
  let dataType = Object.prototype.toString.call(data)
    .replace(/^\[object/, '')
    .replace(/\]$/, '')
    .replace(/\s/, '');
  typeList = flat(typeList);
  let hasType = typeList.some(it => {
    return it && isDataType(it) === 'String';
  });
  if (!hasType) {
    return dataType;
  }
  if (typeList.includes(dataType) || typeList.includes(dataType.toLowerCase())) {
    return true;
  }
  return false;
}

/**
 * 从参数中获取所有Promise对象，组成数组并返回
 * @param  {...any} datas 待解析数据
 */
function getAllPromise (...datas) {
  let promiseList = [];
  datas.forEach(it => {
    if (isDataType(it, 'Promise')) {
      promiseList.push(it);
      return;
    }
    // 是方法则获取执行的结果
    if (isDataType(it, 'Function')) {
      promiseList.push(...getAllPromise(it()));
      return;
    }
    if (isDataType(it, 'Array')) {
      promiseList.push(...getAllPromise(...it));
    }
  });
  return promiseList;
}

/**
 * Array.flat在app和Trident内核上会报错，重写
 * @param {Array} list 目标数组
 */
function flat (list) {
  if (Array.prototype.flat) {
    return list.flat(Infinity);
  }
  let retArr = [];
  if (!Array.isArray(list)) {
    throw new Error(`Invalid parameter: type check failed for parameter 'list'. Expected Array, But got ${typeof list} with value ${list}`);
  }
  list.forEach(it => {
    if (!Array.isArray(it)) {
      retArr.push(it);
      return;
    }
    retArr.push(...flat(it));
  });
  return retArr;
}

// 互联网风险提示
const riskStatement = [
  { text: '您在使用桃子互联网医院提供的“在线常见病、慢性病复诊”诊疗服务（以下简称“本服务”）之前，请务必仔细阅读下列文本。', class: 'margin-top-8' },
  { text: '桃子互联网医院在此郑重提示：一旦您使用了本服务，即表示您已经完整、准确的了解了本声明所提示的所有内容，并同意接受本声明全部条款的约束。您使用桃子互联网医院相关服务时勾选同意的相关授权或协议，及桃子互联网医院已经发布或将来可能发布的各类规则、解释、声明、通告等，以上内容都被视为本知情同意书的组成部分，具有同等的法律效力。', class: 'margin-top-8' },
  { text: '根据《互联网诊疗管理办法（试行）》、《互联网医院管理办法（试行）》、《远程医疗服务管理办法（试行）》等法规的要求，您应知晓互联网诊疗相关的执业规则并接受风险告知并签署知情同意书。', class: 'margin-top-8' },
  { text: '1. 互联网诊疗相关执业规则', class: 'margin-top-8 risk-statement-title' },
  { text: '互联网医院在为您提供部分常见病、慢性病复诊服务时，您需确保已在实体医院完成首诊并已有明确诊断，互联网医院医师掌握您提交的病历等资料，确定已有明确诊断后，可针对相同诊断进行复诊并开具处方。', class: 'margin-top-8' },
  { text: '互联网医院不能开具麻醉药品、精神类药品处方，以及其他用药风险较高，有其他特殊管理规定的药品处方。为6岁以下的儿童开具用药处方时，应当有监护人和相关专业医师陪伴。', class: 'margin-top-8' },
  { text: '互联网医院不能直接进行体格检查和实施检查、检验等诊查手段，一旦医生认为您出现病情变化且需要医务人员亲自诊查时，或复诊疾病属于疑难杂症、出现危急重症等情形时，医生在在线诊疗过程中能够采取的有效措施较为有限。前述情形下医生有权终止本次诊疗活动，您应积极配合到实体医疗机构就诊。', class: 'margin-top-8' },
  { text: '互联网医院可以提供药品配送相关的服务。', class: 'margin-top-8' },
  { text: '2.互联网诊疗潜在风险告知及对策', class: 'margin-top-8 risk-statement-title' },
  { text: '接受互联网诊疗可能出现如下潜在风险，有些不常见的风险未能一一列出，如果您有疑问应与医生讨论。', class: 'margin-top-8' },
  { text: '2.1 受限于互联网诊疗本身的局限性（如医生不能面诊、触诊等，无法通过相关的诊查手段及检查、检验结果准确判断病情的进展），医生给出的本次诊疗方案依赖于您所上传的资料和描述的症状，以及既往的病历资料、临床诊断。如前述信息不准确或不全面，将对本次诊疗方案的合理制定产生一定的影响，如因此导致误诊误治的不利后果，患者需对此承担相应责任。', class: 'margin-top-8' },
  { text: '2.2 由于疾病本身的特殊性和复杂性，您本身的体质状况，及现有医疗水平条件的限制等，都存在可能发生各种并发症和危害自身生命健康的意外风险。', class: 'margin-top-8' },
  { text: '由于疾病本身的复杂性，以及诊疗措施疗效出现的延后性，诊疗方案、健康管理方案可能不会达到您期许的效果，且有些疾病或并发症是不可根治的，需要您积极配合，医生已经尽力为您制定合理的在线诊疗方案，致力减少药物治疗不良反应的发生，但不可能完全避免，且不可预测，需要在您的配合下，且根据临床情况不断调整方案。如果您在在线诊疗中或在线诊疗后，发现自身的症状和体征发生改变或恶化，或有明显的身体不适，请您立即告知医生，并及时就近急诊就医，以免贻误病情。', class: 'margin-top-8' },
  { text: '2.3 您确认为患者本人或监护人，虽然我们对患者的实名信息进行搜集和核验，但平台受限于线上问诊环境，不同于线下现场诊疗，无法实时核验患者的身份。平台及为您提供在线复诊服务的互联网医院将视同您为患者本人或作为患者的监护人。您在在线问诊过程中进行的任何操作行为，对患者均具有对应的法律效力。', class: 'margin-top-8' },
  { text: '2.4 疾病的治愈需要您谨遵医嘱、健康管理方案，并积极配合。如果您未完全遵守和配合，则可能导致诊疗效果不理想，甚至出现病情反复、恶化等不良后果。', class: 'margin-top-8' },
  { text: '2.5 如您正在用药物或手术等治疗其他疾病，也可能存在延时用药、联合用药等风险，此类情形请务必提前告知医生。', class: 'margin-top-8' },
  { text: '2.6您自采药品的品牌、规格、性状、使用方法等可能影响本次诊疗方案的效果，同时还可能出现危害生命健康的风险。', class: 'margin-top-8' },
  { text: '2.7 医生主要解决本专业领域的医疗问题，非本专业的疾病需要到其他专业科室进行诊治或接受远程医疗服务。', class: 'margin-top-8' },
  { text: '本风险告知及知情同意书未能一一列出在线问诊场景下其他可能存在的风险，如果您有疑问请与医生进行沟通。', class: 'margin-top-8' },
  { text: '3. 我们非常重视对您个人健康信息的保护，并遵循合法、正当、必要原则来收集您提交的各项个人健康信息，用于线上医生为您提供服务。', class: 'margin-top-8 risk-statement-title' },
  { text: '您已充分知晓上述内容并作如下确认：', class: 'margin-top-8' },
  { text: '由于医生仅通过在线沟通收集病情资料，您确认如实、完整反馈个人情况（基本信息（真实的姓名、性别、年龄、身份证号））和病症信息（病情描述、过敏史、特殊体质备注等），并对提供信息的真实性准确性负责。', class: 'margin-top-8' },
  { text: '您确认将严格按照医嘱用药，如遇到病情加重或其他严重不适症状应及时线下就医。', class: 'margin-top-8' },
  { text: '在接受在线诊疗服务过程中，请您真实回答医生提出的问题，切勿故意隐瞒或虚报。由此造成的不良后果，由您本人负责。', class: 'margin-top-8' },
  { text: '如您有药物过敏史，您须提前填写清楚，或告知医生或医生团队，同时用药过程中如有不适反应要主动、积极告知平台、医生或医生团队。', class: 'margin-top-8' },
  { text: '您确认在互联网医院上问诊的疾病，已经在实体医疗机构明确诊断，您已经填写或上传相关的病历资料，愿意进行互联网诊疗。', class: 'margin-top-8' },
  { text: '您确认既往发生过与本次发病类似的常见病、慢性病病症，并曾经在实体医院诊疗。', class: 'margin-top-8' },
  { text: '您确认愿意接受医生根据诊疗经验为您提供的在线医疗服务。', class: 'margin-top-8' },
  { text: '您确认已经知晓并同意以上内容，理解相关的风险，愿意接受互联网医院的服务以及接受疾病诊疗服务，并签署知情同意书。', class: 'margin-top-8' },
  { text: '您确认未得到服务结果会百分之百成功的许诺。', class: 'margin-top-8' }
]

// 敏感个人信息处理规则
const sensitivePersonalInformationStatement = [
  { text: '本规则为四川桃子健康科技股份有限公司(以下简称为“我们”)进行敏感个人信息处理规则。您在同意本规则之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款的内容，特别是免除或者限制责任的条款、法律适用和争议解决条款，这些条款将以粗体下划线标识，您应重点阅读。', class: 'margin-top-8' },
  { text: '如果您不同意本规则的任意内容，或者无法准确理解我们对条款的解释，请不要进行任何后续操作。', class: 'margin-top-8' },
  { text: '一、处理目的', class: 'margin-top-8 risk-statement-title' },
  { text: '1、为了正常使用医生咨询服务您需要向我们提供：您以及实际就诊人的真实姓名、手机号码、身份证号码、疾病史、症状信息、生理特征、处方凭证以及症状相关的信息，同时，我们也收集您在咨询过程中的沟通信息，包括文字、图片、语音等信息(基于保护您隐私的必要，您可以自主选择是否关闭您麦克风权限、相册/图片权限、相机权限等)(下称:诊疗信息)。我们将以此为目的而进行使用、共享、存储。我们仅会在您主动选择开启医生咨询服务时进行收集，且仅用于前述场景。', class: 'margin-top-8' },
  { text: '2、我们高度重视对您的信息保护，将会采用严格的技术措施保护您的敏感信息及其关联信息的安全。如果，我们将有关信息用于本协议未载明的其他用途或者将基于特定目的收集而来的信息用于其他目的时，会事先明确征求您的同意。', class: 'margin-top-8' },
  { text: '二、处理方式与权利', class: 'margin-top-8 risk-statement-title' },
  { text: '1、我们将会接入第三方互联网医院、药店为您提供医生咨询服务，您同意我们将您的诊疗信息（含您在过往使用医生在线咨询服务中的信息）提供给三方互联网医院以及药店。同时，药店将获取第三方互联网医院开具的处方单，进行审方开药。', class: 'margin-top-8' },
  { text: '2、我们只会在符合法律法规规定的达成本规则所诉目的所需最短期限内保留您的信息。', class: 'margin-top-8' },
  { text: '3、如您撤回您的诊疗信息，您可以联系桃子健康平台客服进行处理，我们将不再处理您的数据。如您需要再次使用我们的服务，可能会需要再次提供。', class: 'margin-top-8' },
  { text: '三、您的承诺和保证', class: 'margin-top-8 risk-statement-title' },
  { text: '1、您需确保您提供的诊疗信息为您本人的真实信息，如您为他人进行医生咨询，您应当保证您提交的实际就诊人诊疗信息已经经过合法授权且不侵犯任何他方权益。', class: 'margin-top-8' },
  { text: '2、您在使用医生咨询服务期间造成任何第三方人身或财产损害的，由您承担相应法律责任与赔偿责任；您不得使用医生咨询服务从事非法活动。', class: 'margin-top-8' },
  { text: '3、确认本规则前，您已知晓医生咨询服务以及诊疗信息的风险性，也已充分了解相关法律法规或政策等，也已预料到有关规则执行中的商业、法律、政策风险，对本规则所涉内容不存在任何误解或遗漏。', class: 'margin-top-8' },
  { text: '四、其他', class: 'margin-top-8 risk-statement-title' },
  { text: '1、我们可能为适应国家法律法规变化及维护交易秩序、保护消费者权益需要，修改本规则，变更后的规则(下称“变更事项”)将通过公示的方式通知您。', class: 'margin-top-8' },
  { text: '如您不同意变更事项，您有权于变更事项确定的生效日前联系我们反馈意见。如反馈意见得以采纳，我们将酌情调整变更事项。', class: 'margin-top-8' },
  { text: '如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用医生咨询服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用医生咨询服务，则视为您同意已生效的变更事项。但如果我们对收集的诊疗信息的处理目的、处理方式发生变更的，我们会重新取得您的同意。', class: 'margin-top-8' },
  { text: '2、因本规则产生的有关争议，由我们与您协商解决。', class: 'margin-top-8' },
]

// 通过url获取参数
function getUrlParams () {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  let obj = {}
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    obj[pair[0]] = pair[1]
  }
  return obj
}

// 校验
function handleParamsDisease (obj) {
  // 上传凭证
  obj.certificateUrl = this.foreachArray(this.uploadGroup, 'uploadValue', (item) => {
    if (item.uploadValue.indexOf('blob') !== -1) {
      return false
    } else {
      return item.uploadValue
    }
  })
  // 过敏史
  if (this.diseaseHistory.allergy.value === 'yes') {
    obj.historyOfAllergy = 1
    obj.allergyDetail = this.sunmarySelect(this.diseaseHistoryList)
    if (this.diseaseHistory.allergy.supplement !== '') {
      obj.allergyDetail += obj.allergyDetail === '' ? this.diseaseHistory.allergy.supplement : (',' + this.diseaseHistory.allergy.supplement)
    }
    obj.allergyDetail = obj.allergyDetail.replaceAll(' ', '')
    if (obj.allergyDetail === '') {
      this.verificationResult = false
      showNotify({
        type: 'warning',
        message: '请输入过敏史',
        duration: 1000
      });
      return false
    }
  }
  // 过往病逝
  if (this.diseaseHistory.historyMedical.value === 'yes') {
    obj.historyOfSickness = 1
    obj.sicknessDetail = this.diseaseHistory.historyMedical.supplement
    obj.sicknessDetail = obj.sicknessDetail.replaceAll(' ', '')
    if (obj.sicknessDetail === '') {
      this.verificationResult = false
      showNotify({
        type: 'warning',
        message: '请输入过往病史',
        duration: 1000
      });
      return false
    }
  }
  // 备孕
  if (this.diseaseHistory.pregnancy.value === 'yes') {
    let temp = this.sunmarySelect(this.pregnancyList)
    switch (temp) {
      case '妊娠':
        obj.pregnancy = 2;
        break;
      case '哺乳':
        obj.pregnancy = 3;
        break;
      case '备孕':
        obj.pregnancy = 1;
        break;
      default:
        this.verificationResult = false
        showNotify({
          type: 'warning',
          message: '请选择妊娠哺乳备孕',
          duration: 1000
        });
        return false
    }
  }
  // 肝功能
  if (this.diseaseHistory.liver === 'yes') {
    obj.liver = 1
  }
  // 肾功能
  if (this.diseaseHistory.renal === 'yes') {
    obj.renal = 1
  }
  // 选择已确诊疾病
  obj.illDesc = this.sunmarySelect(this.selectList)
  if (obj.illDesc === '') {
    showNotify({
      type: 'warning',
      message: '请选择已确诊疾病',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
  // 姓名
  if (obj.patientName === '') {
    showNotify({
      type: 'warning',
      message: '请输入姓名',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
  // 设身份证
  if (obj.patientIdNo === '') {
    showNotify({
      type: 'warning',
      message: '请输入身份证',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
  // 联系方式
  if (obj.patientPhone === '') {
    showNotify({
      type: 'warning',
      message: '请输入联系方式',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
  let reg = /^1[3456789]\d{9}$/
  if (!reg.test(obj.patientPhone)) {
    showNotify({
      type: 'warning',
      message: '手机号码输入不正确',
      duration: 1000
    })
    this.verificationResult = false
    return false;
  }
  // 性别
  obj.patientSex = this.patientInfo.sex === '男' ? 1 : 2
  // 体重
  if (this.patientInfo.age.split('岁')[0] < 14 && this.verificationUniqueID === 0) {
    if (obj.patientWeight === '') {
      showNotify({
        type: 'warning',
        message: '请填写体重',
        duration: 1000
      })
      this.verificationResult = false
      return false
    } else if (obj.patientWeight < 0.1) {
      showNotify({
        type: 'warning',
        message: '体重格式不正确',
        duration: 1000
      })
      this.verificationResult = false
      return false;
    } else if (obj.patientWeight > 99.9) {
      showNotify({
        type: 'warning',
        message: '体重格式不正确',
        duration: 1000
      })
      this.verificationResult = false
      return false;
    } else if (obj.patientWeight.split('.')[1]) {
      if (obj.patientWeight.split('.')[1].length === 0 || obj.patientWeight.split('.')[1].length > 1) {
        showNotify({
          type: 'warning',
          message: '体重格式不正确',
          duration: 1000
        })
        this.verificationResult = false
        return false;
      }
    }
  }
  obj.patientWeight = obj.patientWeight !== '' ? parseInt(obj.patientWeight) : ''
  // 年龄
  if (parseInt(this.patientInfo.age.split('岁')[0]) === 0 && this.verificationUniqueID === 0) {
    showNotify({
      type: 'warning',
      message: '请填写年龄',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
  obj.patientAge = parseInt(this.patientInfo.age.split('岁')[0]) !== 0 ? parseInt(this.patientInfo.age.split('岁')[0]) : 0
  // 精神病药品
  if (this.userInfo.sectionCode === '15' && obj.certificateUrl === '') {
    showNotify({
      type: 'warning',
      message: '请上传复诊凭证',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
}

/**
 * 根据身份证号计算年龄（按月）和距离一岁生日的月份
 * @param {string} idCard - 身份证号
 * @returns {object} - 包含年龄（以年和月表示）的对象
 */
function calculateAgeAndMonths(idCard) {
  // 从身份证号提取出生日期信息
  const birthYear = parseInt(idCard.substring(6, 10), 10);
  const birthMonth = parseInt(idCard.substring(10, 12), 10);
  const birthDay = parseInt(idCard.substring(12, 14), 10);

  // 获取当前日期
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1; // 月份是从0开始的，需要加1
  const currentDay = today.getDate();

  // 计算出生日期到当前日期的年份和月份差
  let yearDiff = currentYear - birthYear;
  let monthDiff = currentMonth - birthMonth;
  let dayDiff = currentDay - birthDay;

  // 调整月份差值，如果当前月份小于出生月份，则月份差值为负数，需要调整
  if (monthDiff < 0) {
      yearDiff--;
      monthDiff += 12;
  }

  // 调整天数差值，如果天数差值为负数，则月份差值减少1
  if (dayDiff < 0) {
      monthDiff--;
      if (monthDiff < 0) {
          yearDiff--;
          monthDiff += 12;
      }
  }

  // 如果年龄小于1岁，返回以月为单位的年龄
  if (yearDiff === 0) {
      return {
          monthsAge: monthDiff,
      };
  }

  // 如果年龄大于等于1岁，返回以年和月为单位的年龄
  return {
      age: yearDiff
  };
}
export {
  SDKAPPID,
  SECRETKEY,
  riskStatement,
  sensitivePersonalInformationStatement,
  genTestUserSig,
  flat,
  getAllPromise,
  isDataType,
  getUrlParams,
  handleParamsDisease,
  calculateAgeAndMonths
};
